// extracted by mini-css-extract-plugin
export default {"breadcrumbsContainer":"_10z8gqo","breadcrumb-link":"_a0jqph","breadcrumbLink":"_a0jqph"};